import { useTranslation } from 'react-i18next';
import type { NotificationStatus } from '../../../types/notification';

export interface NotificationStatusTagProps {
  readonly status: NotificationStatus;
}

const STATUS_STYLES: Record<NotificationStatus, string> = {
  delivered: 'bg-base-success-100 text-base-success-700',
  scheduled: 'bg-base-warning-100 text-base-warning-700',
  draft: 'bg-base-gray-100 text-base-gray-600',
  cancelled: 'bg-base-danger-100 text-base-danger-700',
  processing: 'bg-base-accent-500 text-base-neutral-white',
};

/**
 * Badge de status de notificação com cores semânticas do design system.
 */
export function NotificationStatusTag({ status }: NotificationStatusTagProps) {
  const { t } = useTranslation('notification');

  return (
    <span
      className={`inline-flex items-center rounded-pill px-micro py-quark ts-caption-xxs whitespace-nowrap ${STATUS_STYLES[status]}`}
    >
      {t(`status.${status}` as never)}
    </span>
  );
}
